import { render, staticRenderFns } from "./singlePaymentPlan.vue?vue&type=template&id=5db5223b&"
import script from "./singlePaymentPlan.vue?vue&type=script&lang=js&"
export * from "./singlePaymentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports